<template>
    <div>
        <div class="comment_conversion mt-4 pl-15">
            <!-- <div v-if="ajaxCallInProgress" class="text-center font-weight-bold" style="background-color: #eff9fd !important;">
                <div>
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                </div>
            </div> -->
            <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div v-if="!ajaxCallInProgress && email_show.length == 0" class="text-center font-weight-bold">
                <div>No Emails Found</div>
            </div>
            <div v-else class="d-flex email_line" v-for="(email,index) in email_show" :key="index">
                <div class="d-flex justify-content-center email_event" style="width:10%;">
                    <span class="unfinishedCircle">
                        <span class="fw-500">{{dateFormat(email.created_date).split(' ')[0]}}</span>
                        <span class="fw-500" style="text-align: center !important;">{{email.created_date.split('-')[1] + ' ' +  email.created_date.split('-')[2]}}</span>
                        <!-- <span class="fw-500">{{dateFormat(email.created_date).split(' ')[0]}}</span>
                        <span class="fw-500">{{dateFormat(email.created_date).split(' ')[1] + ' ' +  dateFormat(email.created_date).split(' ') [2] }}</span>
                        <span class="fw-400">{{email.created_date.slice(11)}}</span> -->
                    </span>
                </div>
                <div class="mt-2" style="width:90%;">
                    <div class="d-flex flex-column">
                        <div class="d-flex">
                            <div class="profileCircle">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="">
                            </div>
                            <div class="d-flex flex-column" >
                                <span class="fs-16 fw-600">{{email.from_name}}</span>
                                <span>{{email.from_email}}</span>
                            </div>
                        </div>
                        <!-- <span class="curve_email"></span> -->
                        <div class="mail_template mr-9">
                            <div style="border-bottom:0.5px solid #bfc1c3" class="bg-white">
                                <h5 class="ml-3 pt-4 fw-500">Subject: {{email.subject}}</h5>
                            </div>
                            <div slot="md-expand" v-if="email.is_html_content">
                                <div class="md-card-list-item-content-wrapper" style="display: block; opacity: 1;padding: 10px 20px; box-shadow: 0px 0px 0px 0.5px #aaaaaa;border-radius: 5px">
                                    <div class="md-card-list-item-content">
                                        <p class="p-description-mail" v-html="email.body">
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p v-html="email.body"></p>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end p-3 mr-5" v-if="!selectedReply.includes(index+'new')">
                            <button class="btn btn-secondary btn-smm ml-2 fs-14" @click="replyMail(index)">
                            <i class="icon icon-reply text-danger fs-18 pb-1"></i>
                                Reply
                            </button>
                        </div>
                        <div>
                            <div class="" v-if="selectedReply.includes(index+'new')">
                                <div>
                                    <div class="ticket_reply pointer mt-7 mb-5 mr-8">
                                        <div>
                                            <div class="" v-if="email.to_email.email">
                                                <multiselect
                                                    v-validate="'required'"
                                                    class="diginew-multiselect approval-manager mt-2"
                                                    name="ticketType"
                                                    v-model="email['to_email']"
                                                    label="name"
                                                    :multiple="false"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    placeholder="Enter Email Id"
                                                    :loading="loadingto" @search-change="getAllUsers"
                                                    :blockKeys="['Delete']" track-id="email_id"
                                                >
                                                <template slot="tag" slot-scope="{ option,remove }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.name }}</span>
                                                        <span class="custom__remove pointer" @click="remove(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUsersto" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <div v-else>
                                                <input v-validate="'required'" name="ticketType" class="inputFieldNew" style="padding-right: 30px !important;" type="email" v-model="email['to_email'].email" placeholder="Enter Email Address" />
                                            </div>
                                            <div class="">
                                                <multiselect
                                                    class="diginew-multiselect approval-manager filter-multiple mt-2"
                                                    v-model="email['cc_list']"
                                                    label="name"
                                                    :multiple="true"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="false"
                                                    :show-labels="false"
                                                    placeholder="Search and Select cc Email Id"
                                                    :loading="loadingcc" @search-change="getAllUsers"
                                                    @remove="remove"
                                                    :blockKeys="['Delete']" track-by="email"
                                                >
                                                <template slot="tag" slot-scope="{ option,remove }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.email }}</span>
                                                        <span class="custom__remove pointer" @click="remove(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUserscc" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <div class="">
                                                <multiselect
                                                    class="diginew-multiselect approval-manager filter-multiple mt-2"
                                                    v-model="email['bcc_list']"
                                                    label="name"
                                                    :multiple="true"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="false"
                                                    :show-labels="false"
                                                    placeholder="Search and Select bcc Email Id"
                                                    :loading="loadingbcc" @search-change="getAllUsers"
                                                    :blockKeys="['Delete']" track-by="email"
                                                    @remove="remove"
                                                >
                                                <template slot="tag" slot-scope="{ option,remove }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.email }}</span>
                                                        <span class="custom__remove pointer" @click="remove(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUsersbcc" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <vue-editor
                                                ondrop="return false;"
                                                class="mt-2"
                                                name="ticket_decription"
                                                v-model="email['email_body']"
                                                placeholder="Reply Here..."
                                                v-validate="'required'"
                                                :useCustomImageHandler="true"
                                                @image-added="handleImageAdded"
                                                :editorToolbar="customToolbar"
                                            ></vue-editor>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end mt-10 mb-3 mr-2">
                                        <button type="button" class="btn btn-danger btn-smm" style="box-shadow: none;" @click="replyMail(index)">
                                            Discard
                                        </button>
                                        <button type="button" :disabled="isMailSent" class="btn btn-success text-white btn-smm ml-3 mr-5" style="box-shadow: none;" @click="mailSend(index)">
                                            Send
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import attachments from "../mixins/attachments.js";
import ticket from '../mixins/ticket.js';
import FileUpload from 'vue-upload-component';
import { SweetModal } from 'sweet-modal-vue';
import convert from '../mixins/convert.js';
import axios from 'axios';
export default {
    props:['ticket_id'],
    mixins: [attachments,ticket,convert],
    components:{
        VueEditor,
        FileUpload,
        SweetModal
    },
    data(){
        return{
            mail_notes:'',
            attachments:[],
            search_key:'',
            emails:[],
            to_email_options:[],
            ccEmail:[],
            cc_email_options:[],
            bccEmail:[],
            bcc_email_options:[],
            email_show:[],
            ajaxCallInProgress:false,
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            loading:false,
            loadingto: false,
            loadingcc: false,
            loadingbcc: false,
            scrollable:false,
            temp_users:[],
            count:0,
            visible:false,
            users:[],
            list_users:[],
            success_msg:'',
            warning_msg:'',
            selectedReply:[],
            isMailSent: false,
            customToolbar: [
                ["bold", "italic", "underline"],
                [{ 'align': ''},{ 'align': 'justify'}, { 'align': 'right' }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link","image"]
            ]
        }
    },
    methods:{
        replyMail(index){
            let newValue = index +'new'
            if (this.selectedReply.find(x => x === newValue)) {
                this.selectedReply = this.selectedReply.filter(function(x) {
                    if (x !== newValue) {
                        return x
                    }
                })
                this.email_show[index].cc_list = []
                this.email_show[index].bcc_list = []
                this.email_show[index].email_body = ''
            }else{
                this.selectedReply.push(newValue)
            }
        },
        handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            let data = new FormData()
            data.append('file', file)
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                onUploadProgress: function (progressEvent) {
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                Editor.insertEmbed(cursorLocation, "image", resumable_url);
                resetUploader();
            })
            .catch(error => {
            })
        },
        mailSend(index){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    let details = this.email_show[index]
                    let params= {
                        attachments:[],
                        bcc_list:details['bcc_list'] || [],
                        cc_list:details['cc_list'] || [],
                        email_body:details['email_body'].replace('<p>','').replace('</p>', '') || '',
                        from_email:{
                            name:details.from_name,
                            email:details.from_email
                        },
                        replied_to:details._id,
                        subject:details.subject,
                        ticket_id:details.ticket_id,
                        to_email:details.to_email
                    }
                    this.confirmReply(params,index)
                }else{
                    this.$toasted.global.error("Please Fill Email Text To Send")
                }
            })
        },
        async confirmReply(params,index){
            try {
                this.isMailSent = true
                let res = await this.replytoEmail(params)
                this.success_msg = res.response
                this.replyMail(index)
                this.getReplyMail()
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
            this.isMailSent = false
        },
        handelDuplicates(){
            const result = [];
            const map = new Map();
            for (const item of this.users) {
                if(!map.has(item.email)){
                    map.set(item.email, true);    // set any value to Map
                    result.push({
                        email:item.email,
                        name:item.name
                    })
                }
            }
            this.users = result
        },
        async getAllUsers(search_key){
            try {
                this.loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let response = await this.getUserEmails(params)
                this.list_users = response.response.emails
                this.list_users.forEach((el,index)=>{
                    let value = {
                        email:el.email_id,
                        name:el.name
                    }
                    this.users.push(value)
                })
                this.count = this.temp_users.length
                this.loading = false
                this.scrollable = false
                this.handelDuplicates()
            } catch (reason) {

            }
        },
        // async reachedEndOfUsers(reached){
        //     this.visible = reached
        //     if (reached) {
        //         if (this.scrollable == false) {
        //             this.loading = true
        //             let params ={
        //                 skip:this.count,
        //                 limit:10,
        //                 search_key:this.search_key
        //             }
        //             let response = await this.getUserEmails(params)
        //             this.temp_users = response.response.emails.length;
        //             if (response.response.skip == this.count) {
        //                 if (this.temp_users > 0) {
        //                     let tempFiles = response.response.emails;
        //                     tempFiles.forEach(el => {
        //                         this.list_users.push(el);
        //                         this.list_users.forEach((el,index)=>{
        //                             let value = {
        //                                 email:el.email_id,
        //                                 name:el.name
        //                             }
        //                             this.users.push(value)
        //                         })
        //                     });
        //                     this.count += response.response.emails.length;
        //                     this.loading = false
        //                 } else {
        //                     this.scrollable = true
        //                     this.loading = false
        //                 }
        //                 this.handelDuplicates()
        //             }
        //             this.loading = false
        //         }
        //     }
        // },
        async reachedEndOfUsersto(reached){
            this.visible = reached
            if (reached) {
                if (this.scrollable == false) {
                    this.loadingto = true
                    let params ={
                        skip:this.count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserEmails(params)
                    this.temp_users = response.response.emails.length;
                    if (response.response.skip == this.count) {
                        if (this.temp_users > 0) {
                            let tempFiles = response.response.emails;
                            tempFiles.forEach(el => {
                                this.list_users.push(el);
                                this.list_users.forEach((el,index)=>{
                                    let value = {
                                        email:el.email_id,
                                        name:el.name
                                    }
                                    this.users.push(value)
                                })
                            });
                            this.count += response.response.emails.length;
                            this.loadingto = false
                        } else {
                            this.scrollable = true
                            this.loadingto = false
                        }
                        this.handelDuplicates()
                    }
                    this.loadingto = false
                }
            }
        },
        async reachedEndOfUserscc(reached){
            this.visible = reached
            if (reached) {
                if (this.scrollable == false) {
                    this.loadingcc = true
                    let params ={
                        skip:this.count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserEmails(params)
                    this.temp_users = response.response.emails.length;
                    if (response.response.skip == this.count) {
                        if (this.temp_users > 0) {
                            let tempFiles = response.response.emails;
                            tempFiles.forEach(el => {
                                this.list_users.push(el);
                                this.list_users.forEach((el,index)=>{
                                    let value = {
                                        email:el.email_id,
                                        name:el.name
                                    }
                                    this.users.push(value)
                                })
                            });
                            this.count += response.response.emails.length;
                            this.loadingcc = false
                        } else {
                            this.scrollable = true
                            this.loadingcc = false
                        }
                        this.handelDuplicates()
                    }
                    this.loadingcc = false
                }
            }
        },
        async reachedEndOfUsersbcc(reached){
            this.visible = reached
            if (reached) {
                if (this.scrollable == false) {
                    this.loadingbcc = true
                    let params ={
                        skip:this.count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserEmails(params)
                    this.temp_users = response.response.emails.length;
                    if (response.response.skip == this.count) {
                        if (this.temp_users > 0) {
                            let tempFiles = response.response.emails;
                            tempFiles.forEach(el => {
                                this.list_users.push(el);
                                this.list_users.forEach((el,index)=>{
                                    let value = {
                                        email:el.email_id,
                                        name:el.name
                                    }
                                    this.users.push(value)
                                })
                            });
                            this.count += response.response.emails.length;
                            this.loadingbcc = false
                        } else {
                            this.scrollable = true
                            this.loadingbcc = false
                        }
                        this.handelDuplicates()
                    }
                    this.loadingbcc = false
                }
            }
        },
        async getReplyMail(){
            try {
                this.ajaxCallInProgress = true
                let params = {
                    ticket_id:this.ticket_id
                }
                let res = await this.getReplyEmails(params)
                this.email_show = res.response
                this.email_show.forEach((el,index)=>{
                    el['to_email'] = {
                        email:el.to_email,
                        name:el.to_name
                    }
                })
                this.email_show.forEach((el, el_index) => {
                    if(!el.is_html_content){
                        let find_img = el.body.split(' ')
                        let new_arr = []
                        if(!find_img.includes('<!DOCTYPE')){
                            find_img.forEach((im, im_index) => {
                                let regex = /[a-zA-Z0-9]{1,}<img+/i
                                if(regex.test(im)){
                                    new_arr.splice(im_index, 0, 'class="w-100"')
                                    new_arr.splice(im_index, 0, im)
                                } else if(im == '<img'){
                                    new_arr.splice(im_index, 0, 'class="w-100"')
                                    new_arr.splice(im_index, 0, im)
                                } else if(im.endsWith('><img')){
                                    let d = im.slice(0,im.length-4)
                                    new_arr.push(d)
                                    new_arr.push('<img class="w-100"')
                                } else {
                                    new_arr.push(im)
                                }
                            })
                        }
                        el.body = new_arr.join(" ")
                    }
                })
                this.ajaxCallInProgress = false
            } catch (reason) {
                console.log(reason)
                this.ajaxCallInProgress = false
            }
        },
        removeCc(option){
            this.product.forEach((el,index)=>{
                if(el._id == option._id){
                    this.product.splice(index,1)
                }
            })
        },
    },
    async mounted(){
        this.getReplyMail()
    },
}
</script>
<style scoped>
.comment_conversion{
    padding: 10px 0px 10px 15px;
    border-bottom: none;
    border-top: 1px solid #aac6ee;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    max-height: 600px;
    overflow-y: scroll;
}
.email_line{
  border-left: 1px solid #005dae;
}
.email_line .email_event:before,
.email_line .email_event:after {
    position: absolute;
    display: block;
    top: 0;
}
.email_line .email_event .unfinishedCircle {
  background: #005dae;
  border-radius: 50%;
  height: 75px;
  width: 75px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  margin-right: 20px;
  position: relative;
  right: 49px;
}
.profileCircle  img{
  height: 50px;
  width: 50px;
  margin-right: 20px;
}
.mail_template{
    background-color: #f2f3f5;
    border-radius: 10px;
}
.mail_reply{
    background-color: #f2f3f5;
    border-radius: 10px;
}
.curve_email{
    border: solid transparent;
    border-top-color: transparent;
    border-width: 13px;
    border-bottom-color: #f2f3f5;
    width: 5px;
    border-radius: 0px;
    margin-left: 10px;
}
.ticket_reply{
    border-radius: 10px;
    box-shadow: -1.5px 2.5px 3px 0 rgba(0, 0, 0, 0.16);
    background-color: #f2f3f5;
}
#file_attach{
    position: relative;
    bottom: 260px;
    left: 670px;
    display: flex;
    align-items: center;
    width: 50px;
}
.to_reply{
    border: none !important;
    border-bottom: 1px solid #bfc1c3 !important;
    border-radius: 0px !important;
    margin-top: 0px !important;
}
.p-description-mail {
    white-space: normal !important;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #4e5764;
    margin-bottom: 30px;
    /* padding-left: 32px; */
}
.p-description-mail {
    overflow-y: visible !important;
    overflow-x: scroll;
}
.description-content{
    line-break: anywhere;
    white-space: pre-wrap;
}
.md-card-list-item-content-wrapper{
    background-color: #fff;
}
</style>